// Module
var code = `<div class="container text-center">
  <div class="row align-items-center vh-100">
    <div class="col">
      <h2 class="btn-spinner"></h2>
    </div>
  </div>
</div>`;
// Exports
module.exports = code;